import { render, staticRenderFns } from "./cookie-policy.vue?vue&type=template&id=86c5bb5e&"
import script from "./cookie-policy.vue?vue&type=script&lang=ts&"
export * from "./cookie-policy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports